import React from "react";
import clsx from "clsx";
import styles from "./ButtonsContainer.module.scss";

type Props = {
  gap?: "regular" | "compact";
  align?: "left" | "center" | "right";
  spacingTop?: "regular" | "compact";
  spacingBottom?: "regular" | "compact";
  mobileFullSize?: boolean;
};

export const ButtonsContainer: React.FC<React.PropsWithChildren<Props>> = ({
  children,
  spacingTop,
  spacingBottom,
  mobileFullSize = false,
  align = "center",
  gap = "regular"
}) => {
  return (
    <div
      className={clsx(styles.buttonsContainer, {
        [styles.gapCompact]: gap == "compact",
        [styles.gapRegular]: gap == "regular",
        [styles.left]: align == "left",
        [styles.center]: align == "center",
        [styles.right]: align == "right",
        [styles.spacingTopRegular]: spacingTop == "regular",
        [styles.spacingTopCompact]: spacingTop == "compact",
        [styles.spacingBottomRegular]: spacingBottom == "regular",
        [styles.spacingBottomCompact]: spacingBottom == "compact",
        [styles.mobileFullSize]: mobileFullSize
      })}
    >
      {children}
    </div>
  );
};
